/**
 * The group cash position (FSD Part 3, 3.2.1 S05) — its own screen beside the
 * published-positions list. The wiring packet spreads
 * `TREASURY_POSITION_GROUP_ROUTES` beside `TREASURY_ROUTES`.
 *
 * `/treasury/positions/group` cannot collide with `/treasury/positions/:id`:
 * that sibling is constrained to digits.
 *
 * Gated on `treasury.position.group.read`, what `GET /treasury-positions/group`
 * declares.
 */

import type { RouteRecordRaw } from 'vue-router'

import { POSITION_GROUP_READ } from '@/modules/treasury/positions/api'

export const TREASURY_POSITION_GROUP_PATH = '/treasury/positions/group'

export const TREASURY_POSITION_GROUP_ROUTES: RouteRecordRaw[] = [
  {
    path: TREASURY_POSITION_GROUP_PATH,
    name: 'treasury-position-group',
    component: () => import('@/modules/treasury/positions/GroupPositionView.vue'),
    meta: {
      titleKey: 'treasury.routeTitles.positionGroup',
      permission: POSITION_GROUP_READ,
    },
  },
]
